/**
 * Imágenes de respaldo (tema táctico / equipamiento) cuando la URL del producto falla.
 * Solo se usan en onError o si no hay image_url.
 */
/** URLs directas upload.wikimedia.org (Special:FilePath falla a menudo en <img>) */
export const PRODUCT_FALLBACK_IMAGES: string[] = [
  "https://upload.wikimedia.org/wikipedia/commons/8/8d/Glock17.jpg",
  "https://upload.wikimedia.org/wikipedia/commons/f/f6/AK-47_assault_rifle.jpg",
  "https://upload.wikimedia.org/wikipedia/commons/e/e0/AR15_A3_Tactical_Carbine_pic1.jpg",
  "https://upload.wikimedia.org/wikipedia/commons/2/22/Remington_870_Shotgun.jpg",
];

const MODEL_FALLBACKS: Array<{ test: (name: string) => boolean; images: string[] }> = [
  {
    // Ejemplo solicitado: "GLOCK 17 AUSTRIA ... CO2 ... POLIMERO ... NEGRA ... SEMI AUTO"
    test: (name) => name.includes("glock") && name.includes("17"),
    images: [
      "https://upload.wikimedia.org/wikipedia/commons/8/8d/Glock17.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/4/41/Glock_17_Gen_5_Gun_%2852953524644%29.jpg",
    ],
  },
  {
    test: (name) =>
      (name.includes("glock") && name.includes("19")) ||
      name.includes("glock 19"),
    images: [
      "https://upload.wikimedia.org/wikipedia/commons/9/9d/Glock19-1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/8/8d/Glock17.jpg",
    ],
  },
  {
    test: (name) => name.includes("ak-47") || name.includes("ak 47") || name.includes("kalashnikov"),
    images: [
      "https://upload.wikimedia.org/wikipedia/commons/f/f6/AK-47_assault_rifle.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/1/18/AK_47.JPG",
    ],
  },
  {
    test: (name) => name.includes("ar-15") || name.includes("ar 15") || name.includes("colt ar"),
    images: [
      "https://upload.wikimedia.org/wikipedia/commons/e/e0/AR15_A3_Tactical_Carbine_pic1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/1/11/AR15.jpg",
    ],
  },
  {
    test: (name) => name.includes("remington 870") || name.includes("m870"),
    images: [
      "https://upload.wikimedia.org/wikipedia/commons/2/22/Remington_870_Shotgun.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/6/61/Remington_M870_Mark_I.jpg",
    ],
  },
];

export function getProductFallbackImages(name: string): string[] {
  const lower = name.toLowerCase();
  const modelMatch = MODEL_FALLBACKS.find((rule) => rule.test(lower));
  const preferred = modelMatch?.images ?? [];
  const merged = [...preferred, ...PRODUCT_FALLBACK_IMAGES];
  return Array.from(new Set(merged));
}

export function hashPick(id: number, name: string, modulo: number): number {
  let h = id * 31;
  for (let i = 0; i < name.length; i++) {
    h = (h << 5) - h + name.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h) % modulo;
}

export function placeholdProductImage(name: string): string {
  const t = name.slice(0, 28) || "Producto";
  return `https://placehold.co/800x600/18181b/d97706/png?font=montserrat&text=${encodeURIComponent(t)}`;
}
